document.addEventListener("turbolinks:load", function() {

    $("#search_fio").keyup(function() {
        var value = this.value.toLowerCase();
        $("table tbody").find("tr").each(function(index) {
            var id = $(this).find("td").first().next().text().toLowerCase();
            $(this).toggle(id.indexOf(value) !== -1);
        });
    });

});